import { render, staticRenderFns } from "./BussinesUnit.vue?vue&type=template&id=658aae60&scoped=true"
import script from "./BussinesUnit.vue?vue&type=script&lang=js"
export * from "./BussinesUnit.vue?vue&type=script&lang=js"
import style0 from "./BussinesUnit.vue?vue&type=style&index=0&id=658aae60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658aae60",
  null
  
)

export default component.exports